import { faPaperPlane } from "@fortawesome/pro-light-svg-icons";

import { T } from "@repo/transifex";

import { Modal } from "../../shared/modal";
import { ModalIcon } from "../../shared/modal-icon";
import { ModalTitle } from "../../shared/modal-title";

export const ModalEmailLoading = () => {
  return (
    <Modal backdropVariant="success">
      <div className="flex flex-col items-center gap-y-16">
        <ModalIcon icon={faPaperPlane} />

        <ModalTitle size="8xl" variant="normal" weight="black">
          <T _str="Sending email" />
        </ModalTitle>
        <p className="text-5xl font-extralight text-kiosk-text-primary">
          <T _str="Please wait..." />
        </p>
      </div>
    </Modal>
  );
};
